import styled from "styled-components";

export const FilterPanel = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  padding: 12px;
`;

export const FilterActions = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 0 0 auto;

  .button-filter-production-plan-supplier {
    min-width: 96px;
    height: 40px;
    background-color: #ffffff !important;
    border: 1px solid #2C589B !important;
    color: #0E0E0E !important;
    border-radius: 1px;
    box-shadow: none;
    margin: 0px !important;

    &:hover:not(:disabled) {
      background-color: var(--color-action-hover) !important;
      border-color: #2C589B !important;
      color: #0E0E0E !important;
    }

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }
  }

  @media (max-width: 1200px) {
    justify-content: stretch;

    .button-filter-production-plan-supplier {
      width: 100%;
    }
  }
`;
